import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/Theme';
import './App.css';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Devis from './pages/Devis';
import Page404 from './pages/Page404';
import Mandat from './pages/Mandat';
import CNJE from './pages/CNJE';
import ENSC from './pages/ENSC';
import Ingenierie from './pages/Ingenierie';
import Conseil from './pages/Conseil';
import Cognitique from './pages/Cognitique';
import PolitiqueConfidentialite from './pages/Politique';
import MentionsLegales from './pages/Mentions';
import CGU from './pages/CGU';
import EspaceMembre from './pages/Membre';
import Dashboard from './dashboard/Dashboard';
import Todolist from './dashboard/Todolist';
import Etudes from './dashboard/Etudes';
import SI from './dashboard/SI';
import Kahoot from './dashboard/Kahoot';
import Parametres from './dashboard/Parametres';
import BanniereCookie from './components/BanniereCookie'

function App() {
  const RoutePrivee = ({ children }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? children : <Navigate to="/"/>;
  };

  return (
    <ThemeProvider> 
      <div className="min-h-screen w-full">
        <BrowserRouter>
          <BanniereCookie/>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="*" element={<Page404/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/devis" element={<Devis/>}/>
            <Route path="/ingenierie" element={<Ingenierie/>}/>
            <Route path="/conseil" element={<Conseil/>}/>
            <Route path="/cognitique" element={<Cognitique/>}/>
            <Route path="/mandat" element={<Mandat/>}/>
            <Route path="/cnje" element={<CNJE/>}/>
            <Route path="/ensc" element={<ENSC/>}/>
            <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite/>}/>
            <Route path="/mentions-legales" element={<MentionsLegales/>}/>
            <Route path="/cgu" element={<CGU/>}/>
            <Route path="/espace-membre" element={<EspaceMembre/>}/>
            <Route path="/dashboard" element={<RoutePrivee><Dashboard/></RoutePrivee>}/>
            <Route path="/todolist" element={<RoutePrivee><Todolist/></RoutePrivee>}/>
            <Route path="/etudes" element={<RoutePrivee><Etudes/></RoutePrivee>}/>
            <Route path="/si" element={<RoutePrivee><SI/></RoutePrivee>}/>
            <Route path="/kahoot" element={<RoutePrivee><Kahoot/></RoutePrivee>}/>
            <Route path="/parametres" element={<RoutePrivee><Parametres/></RoutePrivee>}/>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;